import { TypeFromObjectSchema } from '@readcloud/common';

import { Input } from '@readcloud/component-library';
import { Annotation } from '@readcloud/data';

import { Field, useField } from 'react-final-form';

import * as commonSchemas from './CommonSchemas';

import { Select } from '@readcloud/component-library';
import { Switch } from '@readcloud/ui';

export function annotationToFormValues<A extends Annotation>(annotation: A): A {
  return {
    ...annotation,
    data: {
      ...annotation.data,
      publisherOptions: annotation.options
        ? {
            publisherType: annotation.options.type === 'Publisher',
            status: annotation.options.status || 'Draft',
          }
        : undefined,
    },
  };
}
export function formValuesToAnnotation<
  Anno extends Annotation,
  V extends object
>(
  annotation: Anno,
  {
    publisherOptions,
    ...other
  }: TypeFromObjectSchema<typeof commonSchemas.commonSchema> & V
): Anno {
  //TODO: Get rid of the any
  return {
    ...annotation,
    options: publisherOptions
      ? {
          type: publisherOptions.publisherType ? ('Publisher' as const) : null,
          status: publisherOptions.publisherType
            ? (publisherOptions.status as 'Draft' | 'Published') || null
            : null,
        }
      : annotation.options,
    data: {
      ...annotation.data,
      ...other,
      description: other.description || '',
    } as any,
  };
}
export const CommonFields = (props: {
  showPublisherOptions: boolean;
  showDescription?: boolean;
  fieldClassNames?: string;
}) => {
  const publisherTypeField = useField('publisherOptions.publisherType');

  return (
    <>
      {props.showDescription ? (
        <>
          <span>Description</span>
          <div className="rc-py-1" />
          <Field
            type="text"
            label="Description"
            name="description"
            className={props.fieldClassNames}
          >
            {(props) => <Input name="description" {...props.input}></Input>}
          </Field>
        </>
      ) : null}

      {props.showPublisherOptions ? (
        <>
          <div className="rc-py-1" />
          <Field
            type="checkbox"
            label="Publisher Type"
            name="publisherOptions.publisherType"
            className={props.fieldClassNames}
          >
            {(props) => (
              <div className="rc-flex rc-flex-row rc-items-center">
                <small className="rc-mr-2">Publisher Only</small>
                <Switch
                  className={props.fieldClassNames}
                  checked={props.input.checked}
                  onCheckedChange={props.input.onChange}
                />
              </div>
            )}
          </Field>
        </>
      ) : null}

      {publisherTypeField.input.value ? (
        <>
          <div className="rc-py-1" />
          <Field
            type="input"
            label="Publisher Status"
            name="publisherOptions.status"
            className={props.fieldClassNames}
          >
            {(fieldProps) => (
              <Select
                matchWidth
                options={[
                  { label: 'Draft', value: 'Draft' },
                  { label: 'Published', value: 'Published' },
                ]}
                onSelect={(option) => fieldProps.input.onChange(option.value)}
                value={fieldProps.input.value}
                defaultValue={'Draft'}
              />
            )}
          </Field>
        </>
      ) : null}
    </>
  );
};
